// extracted by mini-css-extract-plugin
export var equalColumn = "_eg-0";